
import React, { useContext, useEffect, useState } from 'react';
import SuccessModal from '../SuccessModal';
import { useNavigate } from 'react-router-dom';
import { getSelectedTabListPickupView, getSelectedTabListView, getUserData, setSelectedTabListPickupView } from '../../utils/localStorage';
import { postStoreRiderJobPickupOrDelivery } from '../../services/StoreRiderInfo/StoreRiderInfo';
import JobRequests from './JobRequests';
import StatusFilterModal from '../StatusFilterModal';
import TabMenu from '../TabMenu';
import StoreMenu from '../StoreMenu';
import ButtonLink from '../../ButtonLink';
import JobRequestsListView from './JobRequestsListView';
import { localeDateEndDate, localeDateStartDate } from '../../constants/DateUtil/DateUtil';
import SchedularModalPickupDelivery from '../SchedularModalPickupDelivery';

const { innerWidth: width, innerHeight: height } = window;


const DeliveryJob = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();

  const storeId = storeData.id;

  const [visible, setVisible] = useState(false);

  const jobType = 'delivery';

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));

  let initialEndDate = new Date();
  initialEndDate.setDate(initialEndDate.getDate() + 30); // subtract 7 days to current date

  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const [showEndDatePicker, setShowEndDatePicker] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [focusedField, setFocusedField] = useState('');
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('ALL');

  const [schedularModalPickupDeliveryVisible, setSchedularModalPickupDeliveryVisible] = useState(false)
  const [schedularDate, setSchedularDate] = useState({});

  const handleCalendarModal = () => {
    setSchedularModalPickupDeliveryVisible(true);
  };

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth() - 120); //

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListPickupView(selectedType);
  };


  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListPickupView();
      setTabularView(selectedInvoiceTypeData?.tabListPickupView || "list");
    } catch {
      setTabularView("list");
    }
  };

  const [orderInfoData, setOrderInfoData] = useState([]);
  const [todayOrderData, setTodayOrderData] = useState([]);
  const fetchRiderJobDeliveryData = data => {
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setTodayOrderData(Res);
        }
      })
      .catch(err => {
        console.error('Rider Job Error:', err);
      });
  };

  useEffect(() => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        'DELIVERY_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
        'OUT_FOR_DELIVERY',
      ],
    };
    fetchRiderJobDeliveryData(data);
    fetchSelectedTabListView()
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        'DELIVERY_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
        'OUT_FOR_DELIVERY',
      ],
    };
    fetchRiderJobDeliveryData(data);
    fetchSelectedTabListView()
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const receiveDataFromStatusFilterModal = selectedStatus => {
    handleConfirmDelivery(selectedStatus)
  };

  const receiveDataFromSchedularModalPickupDelivery = newSchedular => {
    setSchedularDate(newSchedular);
    handleConfirmDelivery(newSchedular);
  };

  const handleConfirmDelivery = (selectedStatus) => {
    // Create a new delivery request object
    setIsLoading(true);
    if (!isGetJobButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGetJobButtonPressed(true);
      setTimeout(() => {
        setIsLoading(false);

        const rawStart = selectedStatus?.newSchedular?.startDate;
        const rawEnd = selectedStatus?.newSchedular?.endDate;

        const resolvedStartDate = rawStart
          ? localeDateStartDate(new Date(rawStart))
          : localeDateStartDate(new Date(startDate));

        const resolvedEndDate = rawEnd
          ? localeDateEndDate(new Date(rawEnd))
          : localeDateEndDate(new Date(endDate));

        const defaultStatusList = [
          'DELIVERY_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
          'OUT_FOR_DELIVERY',
        ];

        // Figure out jobStatus based on which shape selectedStatus came in as
        let jobStatus;

        if (Array.isArray(selectedStatus)) {
          // From receiveDataFromStatusFilterModal: already an array of statuses
          jobStatus = selectedStatus;
        } else if (selectedStatus?.newSchedular?.selectedStatus) {
          // From receiveDataFromOrderBookedFilterModal (e.g. "ORDER_BOOKED")
          jobStatus = [selectedStatus.newSchedular.selectedStatus];
        } else if (selectedStatus === 'ALL') {
          // Explicit "ALL" string
          jobStatus = defaultStatusList;
        } else {
          // From receiveDataFromSchedularModalPickupDelivery: dates only, no status
          jobStatus = defaultStatusList;
        }


        const data = {
          startDate: resolvedStartDate,
          endDate: resolvedEndDate,
          jobStatus: jobStatus
        };
        fetchRiderJobDeliveryData(data);
        setIsGetJobButtonPressed(false);
        fetchSelectedTabListView()
        // Reset the form fields
        let initialStartDate = new Date();
        setStartDate(new Date(initialStartDate));

        let initialEndDate = new Date();
        // Set the minimumDate for the end date picker
        setEndDate(initialEndDate);
      }, 1000); // Replace with actual async operation duration
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i className="pi pi-angle-left" onClick={() => navigate(-1)} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold ">
                Delivery Job
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#55BD5A",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <SchedularModalPickupDelivery
        setSchedularModalPickupDeliveryVisible={setSchedularModalPickupDeliveryVisible}
        schedularModalPickupDeliveryVisible={schedularModalPickupDeliveryVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModalPickupDelivery}
      />

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={'Added'}
        text={'Your Amount is added successfully.'}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          'DELIVERY_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
          'OUT_FOR_DELIVERY',
        ]}
      />

      {tabularView === "tab" && (
        <div
          className="scroll-bar mb-2"
          style={{
            height: height - 80,
            overflowY: "scroll",
          }}
        >
          <JobRequestsListView
            orderInfoData={todayOrderData}
            JobType={jobType}
            storeId={storeId}
            callRequestApi={callRequestApi}
          />
        </div>
      )}

      <div style={{ display: tabularView === "tab" ? "none" : "" }}>
        <JobRequests
          orderInfoData={todayOrderData}
          JobType={jobType}
          storeId={storeId}
          callRequestApi={callRequestApi}
        />
      </div>
      {/* <TabMenu  /> */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default DeliveryJob;
